const validateNonNegativeIntegerOnKeypress = (e) => {
  if (!/[0-9]/.test(e.key)) {
    e.preventDefault();
  }
};

const validateNonNegativeNumberOnKeypress = (e) => {
  if (!/[0-9.]/.test(e.key)) {
    e.preventDefault();
  }
};

/*
Returns an onKeyPress function that rejects invalid characters for a
numeric input field. This is more strict than the default set of
characters allowed. The possible validations have been added as needed
and are not exhaustive.
- For a non-negative integer, only digits are allowed.
- For a non-negative number, only digits and periods are allowed.
*/
export const validateOnKeypress = ({ type, min, step }) =>
  type === 'number' && Number.isInteger(min) && min >= 0
    ? Number.isInteger(step)
      ? validateNonNegativeIntegerOnKeypress
      : validateNonNegativeNumberOnKeypress
    : undefined;

// The touched or error values may be an array, an object, or a single value
// depending on how it was initialized and what the error is. See:
// https://formik.org/docs/api/fieldarray#fieldarray-validation-gotchas
export const asArray = (value) =>
  Array.isArray(value)
    ? value // Array
    : typeof value === 'object' && value !== null
    ? Object.values(value) // Non-null object
    : [value]; // Single value
